export function capitalize(word: any) {
  if (!word) return word;
  return word.replace(/\b(\w)/g, (k: string) => k.toUpperCase());
}
